import { cn } from "@newxsystems/shared";
import { getComponent } from "../../../../client";
import type { IAbyssActionProps } from "./AbyssAction.props";

const styles = {
  primary: "border-flare bg-transparent text-flare hover:bg-flare hover:text-absolute-black",
  secondary:
    "border-fog bg-transparent text-frost hover:border-frost hover:bg-frost hover:text-absolute-black",
  ghost:
    "border-transparent bg-transparent text-primary underline underline-offset-4 hover:text-cyan-trace hover:underline-offset-8",
  destructive: "border-flare bg-flare text-absolute-black hover:bg-transparent hover:text-flare",
} as const;

export const AbyssAction = ({ action, className }: IAbyssActionProps) => {
  const Link = getComponent("Link");
  return (
    <Link
      aria-label={action.accessibilityLabel || undefined}
      className={cn(
        "group/action inline-flex min-h-11 items-center justify-center gap-3 rounded-lg border px-5 py-3 font-abyss-body text-sm font-medium leading-[1.4] transition-[background-color,border-color,color,text-underline-offset] duration-200 ease-out focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring",
        styles[action.style || "primary"],
        className,
      )}
      href={action.href}
      rel={action.openInNewTab ? "noopener noreferrer" : undefined}
      target={action.openInNewTab ? "_blank" : undefined}
    >
      <span>{action.label}</span>
      <span
        aria-hidden="true"
        className="font-abyss-mono text-base leading-none transition-transform duration-200 ease-out group-hover/action:translate-x-1"
      >
        →
      </span>
    </Link>
  );
};

AbyssAction.displayName = "Content::AbyssAction";
